<li>
  <div class="li-title layout-row layout-align-start-center"
       [ngClass]="{'selected-price-plan': pricePlan.id === selectedPricePlanId}"
       (click)="onSelectPricePlan($event)"
       #caret>
    <ng-container *ngIf="pricePlan.children && pricePlan.children.length">
      <button *ngIf="!isExpanded" class="icon-btn padding-0" (click)="onToggleExpand($event)">
        <bringoz-icon iconName="chevron-right" fill="#7E7E7E"></bringoz-icon>
      </button>
      <button *ngIf="isExpanded" class="icon-btn padding-0" (click)="onToggleExpand($event)">
        <bringoz-icon iconName="chevron-down" fill="#7E7E7E"></bringoz-icon>
      </button>
    </ng-container>
    <span class="br-body-2 font-weight-400 primary-100 margin-left-5">{{pricePlan.name}}</span>
    <span class="flex"></span>

    <bringoz-icon *ngIf="pricePlan.default" iconName="skill-outline" fill="#7E7E7E"></bringoz-icon>
    <button class="icon-btn" (click)="onViewPricePlanDrillDown();$event.stopPropagation();">
      <bringoz-icon iconName="open" fill="#266AFF"></bringoz-icon>
    </button>
  </div>
  <ul *ngIf="pricePlan.children && pricePlan.children.length" [class.active]="isExpanded" class="nested">
    <app-price-plan-tree-node *ngFor="let childPricePlan of pricePlan.children"
                              [selectedPricePlanId]="selectedPricePlanId"
                              [pricePlan]="childPricePlan"
                              [expandedNodesMap]="expandedNodesMap"
                              (toggleExpandEvent)="onToggleChildExpand($event)"
                              (viewPricePlanDrillDownEvent)="onViewChildPricePlanDrillDown($event)"
                              (selectPricePlanEvent)="onSelectChildPricePlan($event)">
    </app-price-plan-tree-node>
  </ul>
</li>
